import Section from "components/Section";
import SectionTitle from "components/SectionTitle";
import { FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { GAME_LIST } from "utils/content";

interface GamesProps {
  title?: string;
  reloadOnGameChange?: boolean;
}

const Games = ({ title, reloadOnGameChange }: GamesProps): JSX.Element => {
  const navigate = useNavigate();
  const games = Object.keys(GAME_LIST);

  const handleGameClick = (gameKey: string) => {
    navigate(`/games/${gameKey}#game-container`);
    if (reloadOnGameChange) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      window.location.reload();
    }
  };

  return (
    <Section className="min-h-screen gap-24 max-md:gap-8">
      <div className="w-full flex flex-col gap-2">
        <SectionTitle className="!text-left !text-2xl max-md:text-lg w-full !text-primary">
          {title || "Game Break Zone"}
        </SectionTitle>
        <p className="text-black max-md:text-sm">
          Step away, recharge, and clear your mind. This space is designed for
          quick gaming sessions—whether you want to unwind, spark creativity, or
          simply have fun before getting back to your patients.
        </p>
      </div>

      <div className="flex w-full flex-col gap-16 max-md:gap-4">
        {games.map((g) => {
          const game = GAME_LIST[g as keyof typeof GAME_LIST];
          return (
            <div className="w-full flex-1 inline-flex flex-col justify-start items-start gap-2 group">
              <div className="w-full h-auto aspect-[135/37] rounded-full overflow-hidden">
                <img
                  alt="placeholder"
                  className="w-full h-auto object-cover transition-transform duration-300 transform group-hover:scale-105"
                  src={
                    game?.image || "https://placehold.co/1080x296?text=No Image"
                  }
                />
              </div>
              <div className="px-2 py-4 w-full flex flex-row max-md:flex-col justify-center items-start gap-2">
                <div className="flex-1 px-2 py-4 w-full flex flex-col justify-center items-start gap-2">
                  <div className="justify-start text-primary text-xl max-md:text-lg font-bold font-['Raleway']">
                    {game.title}
                  </div>
                  {game.description && (
                    <div className="justify-start max-md:text-sm text-black font-normal font-['Poppins']">
                      {game.description}
                    </div>
                  )}
                </div>

                <button
                  onClick={() => handleGameClick(g)}
                  className="flex-1 btn btn-primary btn-md max-md:w-full max-md:btn-sm max-w-lg  rounded-full uppercase"
                >
                  Launch Game{" "}
                  <FaChevronRight className="transition-all duration-300 -translate-x-full -scale-105 opacity-0 group-hover:scale-105 group-hover:opacity-100 group-hover:translate-x-0" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};
export default Games;
